export const setUrlParam = (...params) => {
  const url = new URL(window.location);

  params.forEach(item => {
    const [param, value] = item;
    if (
      !value ||
      (typeof value === "object" && Object.keys(value).length === 0)
    ) {
      url.searchParams.delete(param);
    } else {
      url.searchParams.set(param, JSON.stringify(value));
    }
  });

  window.history.pushState(null, null, url);
};
